module.exports = __webpack_public_path__ + "static/btn 2_00008.41a66cd3.png";